module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Settings"},"de":{"title":"Einstellungen"},"fr":{"title":"Paramètres"},"it":{"title":"Impostazione"}}')
  delete Component.options._Ctor
}
